import _Close from "@mui/icons-material/Close";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { COLORS, SIZES, Typography } from '@fupa/fupa-uikit';
import { Dialog as MuiDialog, DialogActions, DialogContent, IconButton } from '@mui/material';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { styled as muiStyled } from '@mui/material/styles';
import styled from 'styled-components';
const CustomDialog = muiStyled(MuiDialog, {
  shouldForwardProp: prop => prop !== 'zIndex'
})(_ref => {
  let {
    zIndex,
    theme
  } = _ref;
  return {
    zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : theme.zIndex.modal
  };
});
const SCTypography = styled(Typography).withConfig({
  componentId: "sc-145v0ws-0"
})(["&&&{", "}"], props => props.titleColor && "\n    color: ".concat(COLORS.white, ";\n    "));
export const Dialog = _ref2 => {
  let {
    children,
    actionAlign = 'space-between',
    actionContent = null,
    closeable = false,
    fullScreen = false,
    handleClose,
    open = false,
    title = '',
    titleColor,
    zIndex,
    ...restProps
  } = _ref2;
  const showActions = actionContent ? /*#__PURE__*/React.createElement(DialogActions, {
    sx: {
      padding: SIZES[16],
      justifyContent: actionAlign
    }
  }, actionContent) : null;
  const showClose = closeable ? /*#__PURE__*/React.createElement(IconButton, {
    "aria-label": "close",
    sx: {
      position: 'absolute',
      right: 8,
      top: 12,
      color: titleColor ? COLORS.white : COLORS.darkerGrey
    },
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(_Close, null)) : null;
  return /*#__PURE__*/React.createElement(CustomDialog, _extends({
    open: open,
    onClose: handleClose,
    fullScreen: fullScreen,
    maxWidth: 'xs',
    zIndex: zIndex
  }, restProps, {
    "data-sentry-element": "CustomDialog",
    "data-sentry-component": "Dialog",
    "data-sentry-source-file": "Dialog.tsx"
  }), /*#__PURE__*/React.createElement(MuiDialogTitle, {
    sx: {
      backgroundColor: titleColor,
      padding: '1rem 1rem 0.5rem'
    },
    "data-sentry-element": "MuiDialogTitle",
    "data-sentry-source-file": "Dialog.tsx"
  }, /*#__PURE__*/React.createElement(SCTypography, {
    titleColor: titleColor,
    variant: "subheading",
    "data-sentry-element": "SCTypography",
    "data-sentry-source-file": "Dialog.tsx"
  }, title), showClose), /*#__PURE__*/React.createElement(DialogContent, {
    dividers: true,
    sx: {
      padding: 0
    },
    "data-sentry-element": "DialogContent",
    "data-sentry-source-file": "Dialog.tsx"
  }, children), showActions);
};